import axios from "axios";

export const ManageCsvFileApiService = {

	getPatientCsvFiles() {
            const url = "/api/patient-csv-file";

    		return axios.get(
    		    url,
    			{
    			    headers: { "X-Requested-With": "XMLHttpRequest" },
    			    withCredentials: true
    			},
    		).then(x => x.data);
    	},

    getPaginatedPatientCsvFiles(
		page,
		pageSize,
		sortField,
		sortDirection,
		searchParams) {

        const url = "/api/patient-csv-file/paginated";

		switch (sortDirection) {
			case 'ascend':
			case 'ASC':
				sortDirection = 'ASC';
				break;
			case 'descend':
			case 'DESC':
				sortDirection = 'DESC';
				break;
			default:
				sortDirection = undefined;
				break;
		}

		if (sortDirection === undefined || sortField === undefined) {
			sortDirection = undefined;
			sortField = undefined;
		}

		return axios.get(url,
			{
				headers: { "X-Requested-With": "XMLHttpRequest" },
				withCredentials: true,
				params: {
					page: page - 1,
					pageSize: pageSize,
					sortField: sortField,
					sortDirection: sortDirection,
					...searchParams
				}
			},
		).then(x => x.data);
	},

    uploadFile(file) {

    		const url = "/api/patient-csv-file/";

    		var formData = new FormData();

    		formData.append('csv-file', file);

    		return axios.post(
    			url,
    			formData,
    			{ headers: { "X-Requested-With": "XMLHttpRequest"},
                 withCredentials: true }
    		);
    },

	deleteFile(fileId) {

		const url = `/api/patient-csv-file/delete/${fileId}`;

		return axios.post(
			url,
			null,
			{ headers: { "X-Requested-With": "XMLHttpRequest"},
			withCredentials: true }
		);
	},

	downloadFile(fileId) {

        const url = `/api/patient-csv-file/${fileId}`;

        return axios.get(
        		url,
        		null,
                {
                    responseType: 'blob',
                    headers: { "X-Requested-With": "XMLHttpRequest"},
                    withCredentials: true
                }
            );
   }
}
